import React, {useCallback, useEffect, useRef, useState} from "react"
import DialogHeader from "@/view/layout/DialogHeader"
import HeaderSpacer from "@/view/layout/HeaderSpacer"
import {BoardData} from "@/service/BoardService";
import BoardDetail from "@/view/board/BoardDetail";
import {USER_ID} from "@/common/Constant";
import BottomButton from "@/view/common/component/button/BottomButton";
import BoardEdit from "@/view/board/BoardEdit";

interface BoardDetailViewParam {
    onClose: () => void,
    board: BoardData | undefined,
    onReturn: () => void
}

const BoardDetailView = (props:BoardDetailViewParam) => {
    const handleOverlayClick = useCallback(() => {props.onClose()}, [props.onClose])
    const [isEditable, setIsEditable] = useState(false)
    const [editing, setEditing] = useState(false)
    const boardEditRef = useRef<{update:() => void}>(null)

    useEffect(() => {
        if(props.board?.writerId == localStorage.getItem(USER_ID) as unknown as number){
            setIsEditable(true)
        }else{
            setIsEditable(false)
        }
    }, [props])

    const goToEdit = () => {
        setEditing(true)

    }

    const updateBoard = () =>{
        if(boardEditRef.current){
            boardEditRef.current.update()
            props.onReturn()
            handleOverlayClick()
        }
    }

    return (
        <>
            <DialogHeader onClose={handleOverlayClick} title={'상세보기'}/>
            <div className={'board'}>
                <HeaderSpacer/>
                {editing
                    ? <BoardEdit board={props.board} ref = {boardEditRef}/>
                    : <BoardDetail board={props.board}/>
                }
            </div>
            {isEditable && !editing
                ? <BottomButton className={'primary'} title={'수정하기'} disabled={false} onClick={goToEdit}/>
                : null
            }
            {editing
                ? <BottomButton className={'primary'} title={'저장하기'} disabled={false} onClick={updateBoard}/>
                : null
            }
        </>
    )
}

export default BoardDetailView